/** @deprecated use isUnifiedReentryMode — same check, clearer name */
export const isUnifiedReentryMode = (flag) =>
  flag === true || flag === "true" || flag === "1" || flag === 1;

export const isUnifiedReviewMode = isUnifiedReentryMode;

/** First wizard step when re-entering after completion (walk from start, prefilled). */
export const UNIFIED_FORM_STEP_ORDER = [
  "patient_demographics_verification",
  "new_patient_intake_form",
  "actvity_consents",
  "emr_history",
  "patient_medical_history",
  "medical_history_questionnaire",
  "upload_required_id",
  "upload_additional_documents",
];

/** Step flags are cleared to 0 when a section is saved; treat 1 / "1" / true as enabled. */
export const isPatientFormStepEnabled = (value) =>
  value === 1 || value === "1" || value === true;

export const getFirstUnifiedFormStepKey = (patientFormResponse) => {
  if (!patientFormResponse) return null;
  for (const key of UNIFIED_FORM_STEP_ORDER) {
    if (key === "new_patient_intake_form") {
      if (
        isPatientFormStepEnabled(patientFormResponse[key]) ||
        patientFormResponse.consent_form
      ) {
        return key;
      }
      continue;
    }
    if (isPatientFormStepEnabled(patientFormResponse[key])) {
      return key;
    }
  }
  return null;
};

/**
 * After completion, DB flags are 0 but unified session manifest still lists steps.
 * Uses session current_step index when mid-walk; falls back to manifest[0] on fresh start.
 */
export const resolveReentryFirstStep = (patientFormResponse, snap) => {
  const manifest = snap?.manifest || snap?.step_manifest || [];
  const rawIdx = snap?.current_step ?? 0;
  const idx =
    manifest.length > 0
      ? Math.min(Math.max(0, Number(rawIdx) || 0), manifest.length - 1)
      : 0;
  if (manifest.length > 0) {
    const item = manifest[idx];
    if (item?.type === "questionnaire") {
      return { key: "unified_questionnaire", mappingId: item.activity_mapping_id };
    }
    if (item?.type === "patient_form" && item.step) {
      return { key: item.step, mappingId: null };
    }
  }

  const fromFlags = getFirstUnifiedFormStepKey(patientFormResponse);
  if (fromFlags) {
    return { key: fromFlags, mappingId: null };
  }

  if (patientFormResponse?.consent_form) {
    return { key: "new_patient_intake_form", mappingId: null };
  }

  return { key: UNIFIED_FORM_STEP_ORDER[0], mappingId: null };
};

/** Re-entry after completion: same UX as a fresh run, with saved answers shown. */
export const isUnifiedStepEditable = () => true;
